// Catálogo único de permisos Cashapp (fuente de verdad para el editor de roles
// y el tab Cashapp del form de usuario).
//
// `key` = nombre del campo en el backend (columna `Cashapp*` de la tabla `role`,
// unificada en Fase 2). `labelKey` / `titleKey` = clave de traducción.
//
// Set depurado del legacy: afuera los permisos muertos, los que se reutilizan de
// cobranzas, y los de aprobación/ERP (no existen en la v2 de cashapp).

export interface CashappPermissionItem {
  key: string;
  labelKey: string;
}

export interface CashappPermissionGroup {
  titleKey: string;
  items: CashappPermissionItem[];
}

export const cashappPermissionGroups: CashappPermissionGroup[] = [
  {
    titleKey: "Clients",
    items: [
      { key: "CashappClientSee", labelKey: "View" },
      { key: "CashappClientImport", labelKey: "Import" },
      { key: "CashappClientExport", labelKey: "Export" }
    ]
  },
  {
    titleKey: "Invoices",
    items: [
      { key: "CashappInvoiceSee", labelKey: "View" },
      { key: "CashappInvoiceImport", labelKey: "Import" },
      { key: "CashappInvoiceAdjunstmentImport", labelKey: "ImportAdjustments" },
      { key: "CashappInvoiceExport", labelKey: "Export" }
    ]
  },
  {
    titleKey: "Payments",
    items: [
      { key: "CashappPaymentSee", labelKey: "View" },
      { key: "CashappPaymentImport", labelKey: "Import" },
      { key: "CashappPaymentAssignClient", labelKey: "AssignClient" },
      { key: "CashappPaymentExport", labelKey: "Export" },
      { key: "CashappPaymentFileDelete", labelKey: "DeleteFiles" },
      {
        key: "CashappManuallyCreatedPaymentEdit",
        labelKey: "EditManualPayment"
      },
      {
        key: "CashappManuallyCreatedPaymentDelete",
        labelKey: "DeleteManualPayment"
      }
    ]
  },
  {
    titleKey: "Conciliation",
    items: [
      { key: "CashappInvoicePaymentSee", labelKey: "View" },
      {
        key: "CashappInvoicePaymentCreateWithClientAndInvoice",
        labelKey: "AllocateWithClientAndInvoice"
      },
      {
        key: "CashappInvoicePaymentCreateWithClientNoInvoice",
        labelKey: "AllocateWithClientNoInvoice"
      },
      {
        key: "CashappInvoicePaymentCreateWithNoClient",
        labelKey: "AllocateWithoutClient"
      },
      { key: "CashappInvoicePaymentEdit", labelKey: "Edit" },
      { key: "CashappInvoicePaymentDelete", labelKey: "Delete" },
      { key: "CashappInvoicePaymentExport", labelKey: "Export" },
      { key: "CashappInvoicePaymentImport", labelKey: "Import" }
    ]
  },
  {
    titleKey: "Receipts",
    items: [
      { key: "CashappReceiptSee", labelKey: "View" },
      { key: "CashappReceiptCreate", labelKey: "Create" },
      { key: "CashappReceiptApprove", labelKey: "Approve" }
    ]
  },
  {
    titleKey: "Rules",
    items: [
      { key: "CashappRuleSee", labelKey: "View" },
      { key: "CashappRuleCreate", labelKey: "Create" },
      { key: "CashappRuleEdit", labelKey: "Edit" },
      { key: "CashappRuleDelete", labelKey: "Delete" }
    ]
  },
  {
    titleKey: "Accounts",
    items: [{ key: "CashappAccountManage", labelKey: "Configure" }]
  },
  {
    titleKey: "Currencies",
    items: [{ key: "CashappCurrencyManage", labelKey: "Configure" }]
  },
  {
    titleKey: "Fields",
    items: [{ key: "CashappFieldsManage", labelKey: "Configure" }]
  },
  {
    titleKey: "AuditLog",
    items: [{ key: "CashappActionLogListSee", labelKey: "View" }]
  }
];

// Todas las keys (campos backend) de los permisos cashapp mostrados en la UI.
export const cashappPermissionKeys: string[] = cashappPermissionGroups.flatMap(
  (group) => group.items.map((item) => item.key)
);
